module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/products@2x_0fdab4.jpg";